import clsx from "clsx";
import React from "react";

export const ProgramDropdownOption = ({ program, className }) => {
  const optionText = program.title;

  return (
    <div className={clsx("program-dropdown-option", className)}>
      <span title={optionText}>{optionText}</span>
    </div>
  );
};
